import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import { Field } from 'redux-form';
import { Select, withBaseProps } from '@topconagriculture/react-components';
import MenuItem from '@material-ui/core/MenuItem';
import { getLanguagesList } from '../../store';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import { notEmpty } from '@topconagriculture/forms';
const styles = (theme) => createStyles({
    wrapper: {},
    flagIcon: {
        width: 15,
        height: 15,
        marginRight: theme.space.margin.small,
    },
});
const LanguageSelect = (props) => {
    const { t, classes, className } = props;
    const { isDisabled, languageList, required = true, testId = 'LanguageSelect', fullWidth = true, showImages = true, fieldName = 'language', fieldPlaceholder = t('common:language_field_placeholder'), fieldLabel = t('common:language_field_label'), fieldEmptyItemLabel = t('common:select_language'), imagesBaseUrl = 'https://tapprodstoragecommon.blob.core.windows.net/graphic-resources/assets/images/common/flags/', } = props;
    const notEmptyMemoized = React.useMemo(() => notEmpty({ t }), [t]);
    const languages = !languageList ? useSelector(getLanguagesList) : languageList;
    if (!languages.length) {
        console.warn('@@TAP/language: No data provided');
        return null;
    }
    const languageMenuItems = languages.map((lang) => (React.createElement(MenuItem, { "data-testid": `${testId}-${lang.code}`, value: lang.code, key: lang.code },
        showImages && React.createElement("img", { className: classes.flagIcon, alt: lang.name, src: `${imagesBaseUrl}${lang.code}.svg` }),
        lang.name)));
    return (React.createElement("div", { className: cn(classes.wrapper, className), "data-testid": `${testId}` },
        React.createElement(Field, { "data-testid": `${testId}-input`, name: fieldName, type: "text", fullWidth: fullWidth, disabled: isDisabled, placeholder: fieldPlaceholder, component: Select, label: fieldLabel, displayEmpty: true, required: required, validate: notEmptyMemoized },
            React.createElement(MenuItem, { value: "", disabled: true }, fieldEmptyItemLabel),
            languageMenuItems)));
};
const ComposedLanguageSelect = compose(withBaseProps({ styles }))(LanguageSelect);
ComposedLanguageSelect.displayName = 'LanguageSelect';
export default ComposedLanguageSelect;
//# sourceMappingURL=LanguageSelect.js.map